import React, { useState } from 'react';
import { X, Mail, User } from 'lucide-react';
import { supabase } from '../lib/supabase';

function SignUpModal({ isOpen, onClose, type = 'mailing' }) {
  const [formData, setFormData] = useState({
    email: '',
    name: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const { error: insertError } = await supabase
        .from('mailing_list')
        .insert([{
          email: formData.email,
          name: formData.name,
          source: 'website'
        }]);

      if (insertError) {
        if (insertError.code === '23505') { // Unique constraint violation
          setError('This email is already subscribed!');
        } else {
          throw insertError;
        }
      } else {
        setSuccess(true);
        setTimeout(() => {
          onClose();
          setSuccess(false);
          setFormData({ email: '', name: '' });
        }, 2000);
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" 
         style={{backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050}}>
      <div className="bg-white rounded shadow-lg p-4 position-relative" style={{maxWidth: '500px', width: '90%'}}>
        <button
          onClick={onClose}
          className="position-absolute btn-close"
          style={{top: '16px', right: '16px'}}
          aria-label="Close"
        />

        {success ? (
          <div className="text-center py-5">
            <div className="text-success mb-3">
              <Mail size={60} />
            </div>
            <h3 className="h4 fw-bold text-dark mb-2">Thanks for subscribing!</h3>
            <p className="text-muted">You'll receive updates and special offers from Mobile Body Therapy.</p>
          </div>
        ) : (
          <>
            <h3 className="h4 fw-bold text-dark mb-3">Join Our Mailing List</h3>
            <p className="text-muted mb-4">Get exclusive offers, wellness tips, and updates delivered to your inbox.</p>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="name" className="form-label fw-semibold">
                  <User className="me-2" size={16} />
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="email" className="form-label fw-semibold">
                  <Mail className="me-2" size={16} />
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your@email.com"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-100 btn btn-warning text-dark py-2 fw-semibold"
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              </button>

              <div className="text-center mt-3">
                <small className="text-muted">
                  Want to book appointments and track your sessions?
                </small>
                <br />
                <a href="https://dashboard.mobilebodytherapy.com" target="_blank" className="text-decoration-none fw-semibold">
                  Create an account instead →
                </a>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default SignUpModal;